import tunnelUIStore from './tunnelUIStore.js';
import tunnelDataStore from './tunnelDataStore.js';

export default {
  modules: {
    ui: tunnelUIStore,
    data: tunnelDataStore,
  },
};
